import { CssType } from 'src/theme/jss-types';

export const UserDetailsModalStyles = (): CssType => ({
  headerRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontWeight: 600,
    marginBottom: 16,
    paddingRight: 32,
  },
  sectionTitle: {
    fontWeight: 600,
    margin: '16px 0 8px',
  },
  detailRow: {
    marginBottom: 4,
  },
  detailLabel: {
    fontWeight: 500,
    marginRight: 4,
  },
  rolesTable: {
    width: '100%',
    borderCollapse: 'collapse',
    '& th, & td': {
      border: '1px solid #f0f0f0',
      padding: 8,
    },
    '& th': {
      background: '#fafafa',
      fontWeight: 600,
    },
  },
  createdText: {
    marginTop: 16,
    color: '#999',
  },
  buttonRow: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: 16,
  },
});

export default UserDetailsModalStyles;
